<template>
  <f7-page>
    <f7-navbar title="404 Nenájdené" back-link="Späť"></f7-navbar>
    <f7-block strong inset>
      <p>Prepáčte</p>
      <p>Požadovaný obsah nebol nájdený.</p>
    </f7-block>
  </f7-page>
</template>
